import React from 'react';
import { Link } from 'react-router-dom';
const PricingStrip = () => {
  return <section className="py-16 bg-blue-50" id="pricing" data-id="element-416">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-417">
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden" data-id="element-418">
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-419">
            <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-420">
              <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-421">
                Affordable & Transparent Pricing
              </h2>
              <p className="text-lg text-gray-600 mb-6" data-id="element-422">
                Plans starting from{' '}
                <span className="font-semibold text-blue-600" data-id="element-423">
                  $349 USD/month
                </span>
              </p>
              <ul className="space-y-3 mb-8" data-id="element-424">
                <li className="flex items-start" data-id="element-425">
                  <svg className="h-5 w-5 text-green-500 mt-1 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-426">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-427"></path>
                  </svg>
                  <span className="text-gray-600" data-id="element-428">
                    Hardware, installation, and IoT monitoring included
                  </span>
                </li>
                <li className="flex items-start" data-id="element-429">
                  <svg className="h-5 w-5 text-green-500 mt-1 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-430">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-431"></path>
                  </svg>
                  <span className="text-gray-600" data-id="element-432">
                    Syrups and consumables billed only as used
                  </span>
                </li>
                <li className="flex items-start" data-id="element-433">
                  <svg className="h-5 w-5 text-green-500 mt-1 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-434">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-435"></path>
                  </svg>
                  <span className="text-gray-600" data-id="element-436">
                    Flexible contracts with no hidden fees
                  </span>
                </li>
              </ul>
            </div>
            <div className="bg-gradient-to-br from-blue-500 to-blue-600 p-8 md:p-12 text-white" data-id="element-437">
              <h3 className="text-2xl font-semibold mb-6" data-id="element-438">What's included:</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-439">
                <div data-id="element-440">
                  <h4 className="font-medium text-lg mb-3" data-id="element-441">Equipment</h4>
                  <ul className="space-y-2" data-id="element-442">
                    <li className="flex items-center" data-id="element-443">
                      <svg className="h-5 w-5 text-blue-200 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-444">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-445"></path>
                      </svg>
                      <span data-id="element-446">Premium dispensing system</span>
                    </li>
                    <li className="flex items-center" data-id="element-447">
                      <svg className="h-5 w-5 text-blue-200 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-448">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-449"></path>
                      </svg>
                      <span data-id="element-450">IoT monitoring devices</span>
                    </li>
                    <li className="flex items-center" data-id="element-451">
                      <svg className="h-5 w-5 text-blue-200 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-452">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-453"></path>
                      </svg>
                      <span data-id="element-454">Water filtration system</span>
                    </li>
                  </ul>
                </div>
                <div data-id="element-455">
                  <h4 className="font-medium text-lg mb-3" data-id="element-456">Services</h4>
                  <ul className="space-y-2" data-id="element-457">
                    <li className="flex items-center" data-id="element-458">
                      <svg className="h-5 w-5 text-blue-200 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-459">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-460"></path>
                      </svg>
                      <span data-id="element-461">Professional installation</span>
                    </li>
                    <li className="flex items-center" data-id="element-462">
                      <svg className="h-5 w-5 text-blue-200 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-463">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-464"></path>
                      </svg>
                      <span data-id="element-465">Quarterly maintenance</span>
                    </li>
                    <li className="flex items-center" data-id="element-466">
                      <svg className="h-5 w-5 text-blue-200 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-467">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-468"></path>
                      </svg>
                      <span data-id="element-469">24/7 technical support</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default PricingStrip;